import {
  AGENT_CITIES_PATH,
  AGENT_COUNTRIES_PATH,
  AGENT_STATES_PATH,
} from "./agentConfig";
import { agentApi } from "./apiClient";
import { asArray, unwrapData } from "./catalog";

function listFrom(payload, key) {
  const data = unwrapData(payload);
  if (Array.isArray(data?.[key])) return data[key];
  if (Array.isArray(payload?.[key])) return payload[key];
  return asArray(data);
}

export async function fetchCountries() {
  const payload = await agentApi.get(AGENT_COUNTRIES_PATH, { authToken: null });
  return listFrom(payload, "countries");
}

export async function fetchStates(countryId) {
  const payload = await agentApi.get(AGENT_STATES_PATH, {
    authToken: null,
    params: { countryId },
  });
  return listFrom(payload, "states");
}

export async function fetchCities(stateId) {
  const payload = await agentApi.get(AGENT_CITIES_PATH, {
    authToken: null,
    params: { stateId },
  });
  return listFrom(payload, "cities");
}

export function findLocationLabel(items, id, idKey, nameKey) {
  const match = (items || []).find((item) => String(item?.[idKey]) === String(id));
  return match?.[nameKey] || "";
}
